import { apiClient } from "@/api/api-client";
import ReactECharts from "echarts-for-react";
import { useEffect, useState } from "react";

const colors = {
	pending: "#f87171",
	caseClosed: "#82ca9d",
};

const FiledVsClosedChart = () => {
	const defaultOptions = {
		legend: {
			top: 16,
		},
		tooltip: {
			trigger: "axis",
			axisPointer: {
				type: "shadow",
			},
		},
		xAxis: {
			type: "value",
			splitNumber: 10,
			minInterval: 1,
		},
		yAxis: {
			type: "category",
			nameTextStyle: {
				fontWeight: "bold",
			},
		},
		grid: {
			left: "3%",
			right: "4%",
			bottom: "6%",
			containLabel: true,
		},
		series: [
			{ type: "bar", color: colors.pending },
			{ type: "bar", color: colors.caseClosed },
		],
		dataset: {},
	};

	const [statistics, setStatistics] = useState(null);

	const fetchData = async () => {
		const response = await apiClient.get("/backoffice/filed-vs-closed");
		if (response?.data) {
			const options: any = {
				...defaultOptions,
				extras: {
					title: "test",
				},
				dataset: {
					source: [["status", "Filed Cases", "Closed Cases"], ...response.data],
				},
			};

			setStatistics(options);
		}
	};

	useEffect(() => {
		fetchData();
	}, []);

	return (
		<div className="grid grid-cols-12 w-full gap-4">
			{statistics && (
				<div className="col-span-12">
					<div className="flex flex-col w-full gap-4">
						<div className="flex flex-col w-full h-auto">
							<div
								style={{
									width: "100%",
									height: 380,
								}}
							>
								<ReactECharts option={statistics} style={{ height: "100%", width: "100%" }} />
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default FiledVsClosedChart;
